import { h, Component } from "preact";
import { route } from 'preact-router';
import linkState from 'linkstate';
import style from "../../../../../style/admin";

import { getApiPath } from "../../../../../path";
import AdminMenu from "../../../../../components/admin/menu";
import AdminMenuArt from "../../../../../components/admin/menu/art";

class AdminArtEditAuthor extends Component {
  state = {
    formData: {
      voornaam: "",
      tussenvoegsel: "",
      achternaam: "",
      geb_land: "",
      jaren: ""
    }
  };

  constructor(props){
    super(props);

    this.ApiGetInfo();
  }

  ApiGetInfo = () => {
    let fetchPath = getApiPath(this.props.lang, `adminArt/authordetail/${this.props.id}`);
    fetch(fetchPath, {
      method: 'get',
      headers: {
        "Authorization": sessionStorage.getItem("vumc-jwt")
      },
    })
    .then(res => res.json())
    .then(result => {
      if (result.status == 200) {
        this.setState(previousState => ({
          ...previousState,
          formData: {
            voornaam: result.data["voornaam"],
            tussenvoegsel: result.data["tussenvoegsel"],
            achternaam: result.data["achternaam"],
            geb_land: result.data["geb_land"],
            jaren: result.data["jaren"]
          }
        }));
      }
    });
  }

  handleSubmit = (event) => {
    event.preventDefault();

    this.setState(previousState => ({
      ...previousState,
      formSubmitted: true
    }), this.validateForm());
  }

  validateForm = () => {
    if ( // required fields
      this.state.formData.achternaam == ""
    ) {
      this.setState(previousState => ({
        ...previousState,
        formValid: false
      }));
    }else{
      this.setState(previousState => ({
        ...previousState,
        formValid: true
      }), this.doSubmit());
    }
  }

  doSubmit = () => {
    let fetchPath = getApiPath(this.props.lang, `adminArt/author/${this.props.id}`);
    fetch(fetchPath, {
      method: 'post',
      headers: {
        "Authorization": sessionStorage.getItem("vumc-jwt")
      },
      body: JSON.stringify(this.state.formData)
    })
    .then(res => res.json())
    .then(result => {
      if (result.status == 200) {
        route(`/${this.props.lang}/admin/art/author`);
      } else {
        alert("Something went wrong");
      }
    });
  }
  
  render() {
    return (
      <div class="admin-page">
        <AdminMenu locale={this.props.lang} />
        <AdminMenuArt locale={this.props.lang} />
        <div>
          <h2>{this.props.lang=='nl'? 'Bewerk kunstenaar':'Edit artist'}</h2>
          <article>
            <form class="admin-form" onSubmit={this.handleSubmit}>
            <div class="form-group">
                <label for="achternaam">{ this.props.lang == 'nl' ? 'Achternaam':'Surname'} <span class="req">*</span></label>
                <input type="text" name="achternaam" id="achternaam" value={this.state.formData.achternaam} onInput={linkState(this, 'formData.achternaam')} />
              </div>

              <div class="form-group">
                <label for="voornaam">{ this.props.lang == 'nl' ? 'Voornaam':'First name'}</label>
                <input type="text" name="voornaam" id="voornaam" value={this.state.formData.voornaam} onInput={linkState(this, 'formData.voornaam')} />
              </div>

              <div class="form-group">
                <label for="tussenvoegsel">{ this.props.lang == 'nl' ? 'Tussenvoegsel':'Middle name'}</label>
                <input type="text" name="tussenvoegsel" id="tussenvoegsel" value={this.state.formData.tussenvoegsel} onInput={linkState(this, 'formData.tussenvoegsel')} />
              </div>

              <div class="form-group">
                <label for="geb_land">Geboorteland</label>
                <input type="text" name="geb_land" id="geb_land" value={this.state.formData.geb_land} onInput={linkState(this, 'formData.geb_land')} />
              </div>

              <div class="form-group">
                <label for="jaren">Geboorte- (en sterf)jaar</label>
                <input type="text" name="jaren" id="jaren" value={this.state.formData.jaren} onInput={linkState(this, 'formData.jaren')} />
              </div>

              {(this.state.formSubmitted && !this.state.formValid) &&
                <div class="form-group">
                    {this.props.lang=='nl'? 'Controleer of alle verplichte velden zijn ingevuld. Deze zijn gemarkeerd met' : 'Please check that all required fields are filled in. These are marked with' } <span class="req">*</span>
                </div>
              }

              <div class="form-group">
                <button>{this.props.lang=='nl'? 'Opslaan':'Save'}</button>
              </div>
            </form>
          </article>
        </div>
      </div>
    )
  }
}

export default AdminArtEditAuthor;